import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { MailAccountsService } from '../../comunications/_services/mail-account.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { MailsAccountDetailComponent } from '../mails-account-detail/mails-account-detail.component';
import { DialogService } from 'primeng/dynamicdialog';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-mails-account-list',
    templateUrl: './mails-account-list.component.html',
    styleUrls: ['./mails-account-list.component.css'],
    host: { class: 'list-page' },
    standalone: false
})
export class MailsAccountListComponent implements OnInit {


    public mailsAccounts: any = [];
    public totalRecords: number = 0;
    public loading: boolean = false;
    private lastGridEvent: any = {
      first: 0,
      rows: 10
    };
    public filters: any = {
      name: new Filter(FilterOperation.contains, 'name'),
      username: new Filter(FilterOperation.contains, 'username'),
    };

    public fieldsConfig: FilterFieldConfig[] = [
      { filter: this.filters.name, type: 'text', label: 'Nombre', base: true },
      { filter: this.filters.username, type: 'text', label: 'Email', base: true }
    ];
    public allowWrite: boolean = false;
    public allowDelete: boolean = false;
    public type: string = "";

  constructor(
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private topbarService: TopbarService,
    private mailAccountsService: MailAccountsService,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private loginService: LoginService
  ) { }

  ngOnInit() {

      this.route.paramMap.subscribe((params: ParamMap) => {      
        this.topbarService.setTitle("Cuentas de correo");   
        this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
          this.edit(null);
        });
        //this.loadData(this.lastGridEvent);
      });
      this.allowWrite = this.loginService.hasPermission("MAIL_ACCOUNTS.WRITE");
      this.allowDelete = this.loginService.hasPermission("MAIL_ACCOUNTS.DELETE");
      
  }


  async loadData($event: any) {
      
      this.lastGridEvent = $event;  
      let params:IParamsCollection = {      
      //  include: ["dataset"],
        page: { number: $event.first+1, size: $event.rows },            
        filter: FilterBuilder.fromObject(this.filters).build()
      }            
      
      if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];  
      let response = await firstValueFrom(this.mailAccountsService.all(params));
      this.mailsAccounts = response.data;
      this.totalRecords = response.meta['total'];
      this.topbarService.setCount(this.totalRecords);
    }
    
    clearFilters() {
      this.filters = {};
      this.search();
    }
  
    search() {
      this.lastGridEvent.first = 0;
      this.loadData(this.lastGridEvent);
    }
  
    edit(id: any) {
      const ref = this.dialogService.open(MailsAccountDetailComponent, {
        closable: true,
        modal: true,
        data: {
          id: id ? id : null
        },
        header: id ? "Modificar cuenta de correo" : "Nueva cuenta de correo",
        width: '40%'
      });
      ref.onClose.subscribe((data: any) => {
        this.loadData(this.lastGridEvent);
      });
    }

    delete(mailAccount: any) {    
      if (this.allowDelete) {      
        this.confirmationService.confirm({
          message: "¿Está seguro que desea eliminar la cuenta de correo "+mailAccount.name+"?",
          header: "Eliminar cuenta de correo",
          acceptLabel: "Aceptar",
          rejectLabel: "Cancelar",
          acceptButtonStyleClass: "p-button-danger",
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.mailAccountsService.delete(mailAccount.id).subscribe({
              next: (data: any) => {
                this.messageService.add({ closable: true, severity: 'success', detail: "Cuenta eliminada correctamente" });
                this.loadData(this.lastGridEvent);
              },
              error: (error: any) => {
                this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
              }
            });
          },
          reject: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    }
    
    open(id: any) {
      window.open(this.mailAccountsService.getMailboxUrl(id), "_blank");
    }

}
